import initialState from "./InitialStates";
import Action from "../actions/Actions";
import update from "immutability-helper";

const DashboardReducer = (state = initialState.dashboard, action) => {
    switch (action.type) {
    case Action.DASHBOARD_REQUEST:
        return update(state, {isLoading: {$set: true}});
    case Action.DASHBOARD_SUCCESS:
        return update(state, {
            isLoading: {$set: false},
            merchantCount: {$set: action.payload.data.merchantCount},
            userCount: {$set: action.payload.data.userCount},
            trnChart : {$set: action.payload.data.montTrnChat},
            ipg: {$set: action.payload.data.ipg}
        });
    case Action.DASHBOARD_FAIL:
        return update(state, 
            {isLoading: {$set: false}
            });    
    default:
        return state;
    }
};

export default DashboardReducer;